module.exports = __webpack_public_path__ + "static/calgary-chamber-ed5d20f294589d69ca830675ca9a6756.png";